module.exports = __webpack_public_path__ + "img/photosession_1_2.db174098.jpg";